import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hubinit.webp';
import screenshot_target from '../../../images/letterfunnel/ericburnik.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Eric Burnik"
      firstname="Eric"
      companyname="Hubinit"
      competition="YouTeam en Malt"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ericburnik.js